"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InchcapeInternalEvents = void 0;
/**
 * Events fired by the widget that are used only internally.
 *
 * These events cannot be captured by host site.
 */
var InchcapeInternalEvents;
(function (InchcapeInternalEvents) {
    InchcapeInternalEvents["SET_STEP"] = "set step";
    InchcapeInternalEvents["TRIGGER_MYACCOUNT"] = "my account";
})(InchcapeInternalEvents = exports.InchcapeInternalEvents || (exports.InchcapeInternalEvents = {}));
